<div class="page">
  <div class="subheader">
    <i class="subicon icon-angle-double-left" (click)="order.closeSidebar()"></i>
    <i class="usericon icon-library_books-o"></i
    ><span>{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.InvoiceChangeFastaccess.BoxTitle" | translate }} </span>
  </div>
  <div class="d-flex">
    <div class="changecard" *ngFor="let item of this.order.currentsaleMethodList" (click)="changeSaleMethod(item)">
      <span>{{ item.SaleMethodTitle }}</span>
    </div>
  </div>
</div>
